import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Textarea,
  Select,
} from "@chakra-ui/react";
import { toast } from "react-toastify";

export default function AddMarkModal({ isOpen, onClose, onSave }) {
  const [mark, setMark] = useState("");
  const [comment, setComment] = useState("");
  const [color, setColor] = useState("");

  const handleSave = () => {
    if (!mark) {
      toast.error("Ocena nie może być pusta");
      return;
    }
    if(mark < 0 || mark > 6) {
      toast.error("Ocena musi być z przedziału od 0 do 6");
      return;
    }
    if(comment.length > 255) {
      toast.error("Komentarz nie może być dłuższy niż 255 znaków");
      return;
    }
    if(comment.length < 3) {
      toast.error("Komentarz musi zawierać przynajmniej 3 znaki");
      return
    }
    if(!color) {
      toast.error("Kolor nie może być pusty");
      return;
    }
    onSave({ mark, comment, color });
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Dodaj ocenę</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Input
            placeholder="Ocena"
            value={mark}
            onChange={(e) => setMark(e.target.value)}
            mb={3}
          />
          <Textarea
            placeholder="Komentarz"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            mb={3}
          />
          <Select
            placeholder="Wybierz kolor"
            value={color}
            onChange={(e) => setColor(e.target.value)}
          >
            <option value="1">Czerwony</option>
            <option value="2">Zielony</option>
            <option value="3">Fioletowy</option>
            <option value="4">Żółty</option>
            <option value="5">Niebieski</option>
          </Select>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={handleSave}>
            Zapisz
          </Button>
          <Button variant="ghost" onClick={onClose}>
            Anuluj
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}